import { useQuery } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { getData } from '@/utils/getData';

const initialCustomerStatus = {
  customerId: null,
  isAuthenticated: false,
  numberOfItemsInBasket: 0,
};

export const useQueryCustomerStatus = () => {
  // SURGE MODE: If basket item count is hidden via CMS feature flag, skip API call for ALL users
  // This reduces server load during high-traffic events (Late Late Toy Show, Black Friday)
  // Cannot use cached AUTH_SETTINGS to differentiate users due to Cloudflare caching
  const hideBasketItemCount = (window as any).HIDE_BASKET_ITEM_COUNT === true;

  // Return early BEFORE calling any hooks to avoid React Query initialization overhead
  if (hideBasketItemCount) {
    return {
      customerId: null,
      isAuthenticated: false,
      isPending: false,
      numberOfItemsInBasket: 0, // Always 0 in surge mode
    };
  }

  // Surge mode disabled: make API call for all users
  const { data, isPending } = useQuery({
    queryFn: getData(Endpoint.CustomerStatus),
    queryKey: [QueryKey.CustomerStatus],
  });

  const { customerId, isAuthenticated: apiIsAuthenticated, numberOfItemsInBasket } =
    data ?? initialCustomerStatus;

  return { customerId, isAuthenticated: apiIsAuthenticated, isPending, numberOfItemsInBasket };
};
